import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
	LegalList,
	LegalPageLayout,
	LegalSection,
} from "#/components/legal/LegalPageLayout";

export const Route = createFileRoute("/accessibility")({
	component: AccessibilityPage,
});

function AccessibilityPage() {
	const { t } = useTranslation("legal");
	const rawT = t as unknown as (key: string, opts: object) => string[];
	const tList = (key: string) => rawT(key, { returnObjects: true });

	return (
		<LegalPageLayout
			tag={t("accessibility.tag")}
			title={t("accessibility.title")}
			updated={t("accessibility.updated")}
		>
			<p className="text-sm leading-relaxed text-muted-foreground">
				{t("accessibility.intro")}
			</p>

			<LegalSection heading={t("accessibility.compliance.heading")}>
				<p>{t("accessibility.compliance.body")}</p>
			</LegalSection>

			<LegalSection heading={t("accessibility.knownIssues.heading")}>
				<p>{t("accessibility.knownIssues.intro")}</p>
				<LegalList items={tList("accessibility.knownIssues.items")} />
			</LegalSection>

			<LegalSection heading={t("accessibility.feedback.heading")}>
				<p>{t("accessibility.feedback.body")}</p>
			</LegalSection>

			<LegalSection heading={t("accessibility.enforcement.heading")}>
				<p>{t("accessibility.enforcement.body")}</p>
			</LegalSection>

			<LegalSection heading={t("accessibility.assessment.heading")}>
				<p>{t("accessibility.assessment.body")}</p>
			</LegalSection>
		</LegalPageLayout>
	);
}
